"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_values_model_1 = require("./shared-values.model");
var use_shared_value_1 = require("./use-shared-value");
var use_once_1 = require("../use-once");
var SharedValueInitStatus;
(function (SharedValueInitStatus) {
    SharedValueInitStatus[SharedValueInitStatus["NotStarted"] = 0] = "NotStarted";
    SharedValueInitStatus[SharedValueInitStatus["Loading"] = 1] = "Loading";
    SharedValueInitStatus[SharedValueInitStatus["Error"] = 2] = "Error";
    SharedValueInitStatus[SharedValueInitStatus["Complete"] = 3] = "Complete";
})(SharedValueInitStatus || (SharedValueInitStatus = {}));
function useSingletonInitialization(key, fetch, apply) {
    var statusKey = getStateKey(key);
    var state = use_shared_value_1.useSharedValue(statusKey)[0];
    use_once_1.useOnce(initialize);
    function initialize() {
        if (state.status !== SharedValueInitStatus.NotStarted)
            return;
        try {
            state.status = SharedValueInitStatus.Loading;
            var response = fetch();
            if (isAsyncResponse(response)) {
                handleAsyncValue(response);
            }
            else {
                handleValue(response);
            }
        }
        catch (error) {
            handleError(error);
        }
    }
    function handleAsyncValue(response) {
        response.then(function (value) { return handleValue(value); }).catch(function (error) { return handleError(error); });
    }
    function handleValue(value) {
        state.status = SharedValueInitStatus.Complete;
        apply(value);
    }
    function handleError(error) {
        state.status = SharedValueInitStatus.Error;
        state.error = error;
    }
    function isAsyncResponse(response) {
        return !!response['then'];
    }
    var loading = state.status === SharedValueInitStatus.Loading || state.status === SharedValueInitStatus.NotStarted;
    return [loading, state.error];
}
exports.useSingletonInitialization = useSingletonInitialization;
function defaultState() {
    return { status: SharedValueInitStatus.NotStarted, error: undefined };
}
function getStateKey(key) {
    return shared_values_model_1.createSharedValueKey(key.id + ":status", defaultState());
}
//# sourceMappingURL=data:application/json;base64,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